import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, retry, tap } from 'rxjs/operators';
import * as moment from 'moment';
import { parseURI } from "uri-parse-lib"
declare var require: any;
const  SHA1 = require('sha1');

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let todayDate = moment(new Date()).format('YYYY-MM-DD');
    let fullURL = parseURI(request?.url) || null;
    let relativeApiPath = fullURL?.pathname?.replace('/wp-json', '');
    let urlToken = `${todayDate}_SwaminarayanBhagwan_${relativeApiPath}`;

    // Don't set Content-Type for FormData (file uploads)
    if (request.body instanceof FormData) {
      return next.handle(
        request.clone({
          setHeaders: {
            "TOKENKEY": "xwBv2nnlxKubZOtKwVkLajYiD4gPTF9k",
            'X-CONTENT-OPTION-ID': SHA1(urlToken)
          }
        })
      );
    }

    return next.handle(
      request.clone({
        setHeaders: {
          "Content-Type": "application/json",
          "TOKENKEY": "xwBv2nnlxKubZOtKwVkLajYiD4gPTF9k",
          'X-CONTENT-OPTION-ID': SHA1(urlToken)
        }
      })
    )
  }
}